import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import Loader from '~/components/core/loader'

Vue.use(InfiniteLoading, {
	slots: {
		spinner: Loader,
		noResults: { render: (h) => h('div') },
		error: {
			render: (h) => h('div'),
		},
	},
})
